import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { AIUsageResponse } from '@/api/ai';

const formatAiRenewalDate = (date?: string | null) => {
    if (!date) return null;

    return format(new Date(date), 'dd/MM/yyyy', {
        locale: ptBR,
    });
};

const formatAiUsageNumber = (value: number) => new Intl.NumberFormat('pt-BR').format(value);

export const getAiUsagePercent = (usage?: AIUsageResponse | null) => {
    const limit = usage?.limit ?? 0;
    const used = usage?.used ?? 0;

    return limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
};

export const isAiUsageExhausted = (usage?: AIUsageResponse | null) => {
    const limit = usage?.limit ?? 0;
    const used = usage?.used ?? 0;

    return limit > 0 && used >= limit;
};

export const getAiUsageMessage = (usage?: AIUsageResponse | null) => {
    if (!usage) return null;

    const usageLabel = `${formatAiUsageNumber(usage.used)} de ${formatAiUsageNumber(usage.limit)}`;
    const renewalDate = formatAiRenewalDate(usage.renews_at);
    const usagePercent = getAiUsagePercent(usage);

    return renewalDate
        ? `Você já usou ${usagePercent}% dos créditos de IA deste ciclo (${usageLabel}). Renovação em ${renewalDate}.`
        : `Você já usou ${usagePercent}% do limite atual de IA (${usageLabel}). Este limite não tem renovação automática.`;
};
